// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2712":"f6211600","3464":"86c2bdef","5585":"9fa230de"}[chunkId] + ".chunk.css";
};